import type { SVGProps } from 'react';

const SvgRealEstateAgent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M1 22h4V11H1zM14 1.5l-7 5V9h2l10 4v2h2V6.5zm-.5 8.5h-1V9h1zm0-2h-1V7h1zm2 2h-1V9h1zm0-2h-1V7h1zM22 19l-8 3-7-1.98V11h1.97L17 14v2h-4l-1.76-.68-.33.94L13 17h9z" />
  </svg>
);
export default SvgRealEstateAgent;
